// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import NormalGameManager from "../../../manager/NormalGameManager";
const {ccclass, property} = cc._decorator;

const c_addLv = 3;
@ccclass
export default class SuperPowerSelect4 extends BasePopUpLayer {
   
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

    }

    onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.addGoods();
        this.destroyNode();
        this._carryData.parent.showEndUI('我们下次再见');
    }

    addGoods() {
        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        let officialLv = gameData.m_officialLv;
        let m_reputation = gameData.m_reputation;

        let exp = this.getLvExp(officialLv + c_addLv);
        if (isNaN(exp)) {
            console.error('数据错误');
            return;
        }
        exp = Math.max(m_reputation, exp);
        NormalGameManager._instance.addExp(exp - m_reputation);
    }

    getLvExp(lv: number) {
        let maxLv = CsvDataManage.instance.getMaxLv();
        let clv = Math.min(lv, maxLv);
        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEVEL, clv);
        if (!info) {
            return 0;
        }
        let exp = info.exp.replace(/,/g, '');
        return Number(exp);
    }
    

    // update (dt) {}
}
